/**
 * Activity グリッド: 行数拡張 + AJAX ロードモア（Classes詳細ページ）
 *
 * HTML:
 *   <div data-activity-load-more
 *        data-rows-increment="2"
 *        data-per-page="14"
 *        data-action="danc_classes_activity_load_more"
 *        [data-has-more]
 *        [data-classes-id="123"]>
 *     <div class="activity-grid-wrap">
 *       <div class="activity-grid">...</div>
 *     </div>
 *     <button class="load-more-btn">View more</button>
 *   </div>
 */
(function () {
  var containers = document.querySelectorAll('[data-activity-load-more]');
  if (!containers.length) return;

  function getRowCount(grid) {
    var rows = getComputedStyle(grid).gridTemplateRows;
    return rows.split(' ').filter(function (v) { return v !== '0px'; }).length;
  }

  function getColCount(grid) {
    return getComputedStyle(grid).gridTemplateColumns.split(' ').length;
  }

  containers.forEach(function (container) {
    var grid = container.querySelector('.activity-grid');
    var btn = container.querySelector('.load-more-btn');
    if (!grid || !btn) return;

    var rowsIncrement = parseInt(container.dataset.rowsIncrement) || 2;
    var perPage = parseInt(container.dataset.perPage) || 14;
    var action = container.dataset.action || '';
    var hasMore = container.dataset.hasMore !== undefined;
    var classesId = container.dataset.classesId || '';
    var category = container.dataset.category || '';
    var currentPage = 1;
    var isLoading = false;

    btn.addEventListener('click', function () {
      if (isLoading) return;

      // 1. 行数を増やす
      var currentRows = getRowCount(grid);
      var newRows = currentRows + rowsIncrement;
      grid.style.gridTemplateRows = 'repeat(' + newRows + ', auto)';

      // 2. AJAX が必要か判定
      var cols = getColCount(grid);
      var needed = newRows * cols;
      var loaded = grid.children.length;

      if (loaded < needed && hasMore) {
        isLoading = true;
        btn.classList.add('is-loading');

        var formData = new FormData();
        formData.append('action', action);
        formData.append('nonce', dancActivityData.nonce);
        formData.append('page', currentPage + 1);
        if (classesId) formData.append('classes_id', classesId);
        if (category) formData.append('category', category);
        formData.append('lang', dancActivityData.lang || 'ja');

        fetch(dancActivityData.ajaxurl, {
          method: 'POST',
          body: formData,
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (!data.success) return;

            grid.insertAdjacentHTML('beforeend', data.data.html);
            currentPage = data.data.page;
            hasMore = data.data.has_more;

            checkButtonVisibility(newRows);

            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                document.dispatchEvent(new CustomEvent('danc:events-loaded'));
              });
            });
          })
          .catch(function (e) { console.error('Activity load more error:', e); })
          .finally(function () {
            isLoading = false;
            btn.classList.remove('is-loading');
          });
      } else {
        checkButtonVisibility(newRows);
      }
    });

    function checkButtonVisibility(visibleRows) {
      var cols = getColCount(grid);
      var totalItems = grid.children.length;
      var visibleCapacity = visibleRows * cols;

      if (!hasMore && totalItems <= visibleCapacity) {
        btn.style.display = 'none';
      }
    }
  });
})();
